import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Card,
  CardContent,
} from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ padding: "2rem 1rem" }}>
    <Typography
      variant="h4"
      component="h1"
      gutterBottom
      align="center"
      sx={{ color: "#fff",fontWeight: 900 }}
    >
      Privacy Policy
    </Typography>
  
    <Card
      sx={{
        marginBottom: "1.5rem",
        backgroundColor: "#B6BFE04D",
        color: "#fff",
        border: "2px solid #B6BFE080",
      }}
    >
      <CardContent>
        <Typography variant="body1" sx={{ color: "#fff",marginBottom:"5px" }}>
        <strong>Background:</strong>
        </Typography>
        <Typography variant="body1" sx={{ color: "#fff" }}>
          At Europa Solutions, we respect your privacy and are committed to
          protecting your personal data. This Privacy Policy explains how we
          collect, use, and store your personal information when you visit our
          website, europasolutions.co.uk. By using our site, you agree to the
          terms of this policy.
        </Typography>
      </CardContent>
    </Card>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">1. Definitions</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{color: "#000", backgroundColor: "#B6BFE04D" }}>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "5px" }}><strong>Personal Data:</strong> Any information that can identify you (e.g., name, contact details, IP address).</li>
          <li style={{ marginBottom: "5px" }}><strong>Cookies:</strong> Small files placed on your device to improve your experience on our website (more details in our Cookie Policy).</li>
          <li style={{ marginBottom: "5px" }}><strong>Data Protection Legislation:</strong> Laws that protect personal data, including the UK GDPR.</li>
        </ul>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">2. About Us</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{color: "#000", backgroundColor: "#B6BFE04D" }}>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>
              <strong>Company Name:</strong> Europa Solutions Limited
            </li>
            <li style={{ marginBottom: "5px" }}>
              <strong>Company Number:</strong> 07827816
            </li>
            <li style={{ marginBottom: "5px" }}>
              <strong>Registered Address:</strong> 18 Lincoln Drive, Houlton, Rugby, England, CV23 1BS
            </li>
            <li style={{ marginBottom: "5px" }}>
              <strong>Contact Email:</strong> <a href="mailto:office@europasolutions.co.uk">office@europasolutions.co.uk</a>
            </li>
          </ul>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">3. What Does This Policy Cover?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{color: "#000", color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          This Privacy Policy applies only to europasolutions.co.uk. We are not responsible for how other websites collect or use your data. Always check their privacy policies before providing your information.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">4. What Is Personal Data?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          Personal data is any information that can identify you, such as your name, email, IP address, and other online identifiers.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">5. Your Rights</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "5px" }}><strong>Right to be informed:</strong> You have the right to know how we use your data.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to access:</strong> You can request access to your personal data.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to correct:</strong> You can request changes to any incorrect data.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to delete:</strong> You can request the deletion of your personal data.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to restrict:</strong> You can restrict how we use your data.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to object:</strong> You can object to certain data uses.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to withdraw consent:</strong> If you’ve given consent, you can withdraw it at any time.</li>
          <li style={{ marginBottom: "5px" }}><strong>Right to data portability:</strong> You can request your data in a machine-readable format.</li>
          <li style={{ marginBottom: "5px" }}><strong>Automated decisions:</strong> We do not use your data for automated decision-making or profiling.</li>
        </ul>
        <Typography variant="body1" sx={{color:"#000"}}>
          For more information or to exercise your rights, contact us at <a href="mailto:office@europasolutions.co.uk">office@europasolutions.co.uk</a>
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">6. What Data Do You Collect and How?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          Depending on how you use the website, we may collect different types of personal data, such as your name, email, contact details, or payment information. We also collect technical data like IP addresses, browser details, and other technical information. We may use cookies or similar technology to help with this process. We don’t collect sensitive data like personal information about children or criminal convictions.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">7. How Do We Use Your Data?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          We use your personal data to provide services, process payments, communicate with you, improve our website, and fulfill our legal obligations. For example, we may use your email to send updates or marketing information, but you can opt-out at any time.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">8. Data Security</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          We take appropriate measures to protect your personal data from unauthorized access, use, or disclosure. However, no security system is completely foolproof, so we cannot guarantee the absolute security of your data.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">9. How Long Do We Keep Your Data?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          We will retain your personal data for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. After that, we will securely dispose of your data.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">10. Changes to This Policy</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{color:"#000"}}>
          We may update this Privacy Policy from time to time. When we do, we will post the revised policy on our website and update the "Last Updated" date at the top of this page. We encourage you to review the policy periodically to stay informed about how we protect your data.
        </Typography>
      </AccordionDetails>
    </Accordion>
  </Container>
  
  );
};

export default PrivacyPolicy;
